import type { VerificationMethods } from '@tenfour/contracts'
import type { AuthUser } from '@/components/auth/AuthContext'
import { listPasskeys } from '@/lib/passkey'
import { verificationApi } from '@/lib/verification'

/** Optional post-login enrollment. A failed status read must never block login. */
export async function getSecuritySetupOffer(user: AuthUser | null): Promise<VerificationMethods | null> {
  if (!user || user.role === 'ADMIN') return null
  try {
    const methods = await verificationApi<VerificationMethods>('methods')
    if (methods.methods.length > 0) return null
    const passkeys = await listPasskeys()
    return passkeys.length === 0 ? methods : null
  } catch {
    return null
  }
}
